import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/login",
  },
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login/Login.vue"),
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/Logout/Logout.vue"),
    meta: {
      requiresAuth: true,
      authority: [
        "admin",
        "advanced",
        "basic",
        "illustrator",
        null,
        "register",
      ],
    },
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home/Home.vue"),
    meta: {
      requiresAuth: true,
      authority: [
        "admin",
        "advanced",
        "basic",
        "illustrator",
        null,
        "register",
      ],
    },
  },
  {
    path: "/list_materials",
    name: "ListMaterials",
    component: () => import("../views/ListMaterials/ListMaterials.vue"),
    meta: {
      requiresAuth: true,
      authority: ["admin", "advanced", "basic", "illustrator"],
    },
  },
  {
    path: "/design_customizations",
    name: "DesignCustomizations",
    component: () =>
      import("../views/DesignCustomizations/DesignCustomizations.vue"),
    meta: {
      requiresAuth: true,
      authority: ["admin", "advanced", "basic", "illustrator"],
    },
  },
  {
    path: "/products",
    name: "Products",
    component: () => import("../views/Products/Products.vue"),
    meta: {
      requiresAuth: true,
      authority: ["admin", "advanced", "basic", "illustrator"],
    },
  },
  {
    path: "/prisma-admin",
    name: "PrismaAdmin",
    component: () => import("../views/PrismaAdmin/PrismaAdmin.vue"),
    meta: {
      requiresAuth: true,
      authority: ["admin", "advanced", "illustrator"],
    },
  },
  {
    path: "/prisma-admin/:identifier/:material",
    name: "PrismaAdmin",
    component: () => import("../views/PrismaAdmin/PrismaAdmin.vue"),
    meta: {
      requiresAuth: true,
      authority: ["admin", "advanced", "illustrator"],
    },
  },
  {
    path: "/similar_groups",
    name: "SimilarGroups",
    component: () => import("../views/SimilarGroups/SimilarGroups.vue"),
    meta: { requiresAuth: true, authority: ["admin", "advanced", "register"] },
  },
  {
    path: "/mockups",
    name: "Mockups",
    component: () => import("../views/Mockups/Mockups.vue"),
    meta: { requiresAuth: true, authority: ["admin", "advanced", "register"] },
  },
  {
    path: "/render_material",
    name: "RenderMaterial",
    component: () => import("../views/RenderMaterial/RenderMaterial.vue"),
    meta: { requiresAuth: true, authority: ["admin", "advanced", "register"] },
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/Admin/Admin.vue"),
    meta: { requiresAuth: true, authority: ["admin"] },
  },
  {
    path: "/fonts",
    name: "Fonts",
    component: () => import("../views/Fonts/Fonts.vue"),
    meta: {
      requiresAuth: true,
      authority: ["admin", "advanced", "illustrator", "register"],
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!store.getters.logged)
    store.dispatch("checkSession", {
      callback: () => runRoute(to, from, next, store.getters),
    });
  else runRoute(to, from, next, store.getters);
});

function runRoute(to, from, next, { logged, authority }) {
  const check = (arr, compare) => (!arr ? false : arr.includes(compare));
  const hasAccess = to.matched.some((record) =>
    check(record.meta.authority, authority)
  );
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth && !logged) next("login");
  else if (!requiresAuth && logged) next("home");
  else if (!hasAccess && to.path !== "/home" && to.path !== "/login")
    next("home");
  else next();
}

export default router;
